<div class="full-page">
  <div>
    <div style="display: block; width: 350px; height: 188px" *ngIf="showChart">
      <canvas
        baseChart
        [data]="pie.data"
        type="pie"
        [options]="pie.options"
        (chartClick)="pie.chartClicked($event)"
      ></canvas>
    </div>
    <h4 style="display: inline">
      {{ selectedStatus ? selectedStatus.name : settings.lang.deliveries }}
    </h4>
    <a
      [style.visibility]="selectedStatus ? 'visible' : 'hidden'"
      (click)="selectedStatus = undefined; refreshDeliveries()"
      style="display: inline"
      >{{ settings.lang.showAll }}</a
    >
    <div
      style="
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
        height: 37px;
        width: 100%;
      "
    >
      <div>
        <button mat-raised-button (click)="selectDeliveries()" *ngIf="!drawing">
          {{ settings.lang.selectDeliveriesOnMap }}
        </button>
        <span *ngIf="drawing">{{ settings.lang.drawingHelpText }}</span>
        <br />
      </div>

      <div>
        <div *ngIf="!drawing && selectedDeliveries.length">
          <strong *ngIf="!drawing && selectedDeliveries.length"
            >{{ selectedDeliveries.length }}
            {{ settings.lang.selectedDeliveries }}</strong
          >
          <mat-menu #appMenu77>
            <ng-container *ngFor="let b of buttons">
              <button
                mat-menu-item
                (click)="b.click()"
                *ngIf="!b.visible || b.visible()"
              >
                {{ b.textInMenu ? b.textInMenu() : b.name }}
              </button>
            </ng-container>
          </mat-menu>

          <button mat-icon-button [matMenuTriggerFor]="appMenu77">
            <mat-icon>more_vert</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div #gmap class="grow-item"></div>
  <div>
    <button
      mat-mini-fab
      style="margin: 5px"
      (click)="refreshDeliveries()"
      color="primary"
    >
      <mat-icon>refresh</mat-icon>
    </button>
    <button
      mat-mini-fab
      style="margin-bottom: 5px"
      (click)="showChart = !showChart"
      color="primary"
    >
      <mat-icon *ngIf="showChart">unfold_less</mat-icon>
      <mat-icon *ngIf="!showChart">unfold_more</mat-icon>
    </button>
    <mat-checkbox
      (change)="refreshDeliveries()"
      [(ngModel)]="showHelper"
      style="margin-right: 10px"
      *ngIf="!overviewMap"
    ></mat-checkbox>
    <data-area [settings]="area" style="display: inline-block"></data-area>
  </div>
</div>
